import { useCallback, useEffect, useState } from "react";

export type VagasViewMode = "kanban" | "list";

const STORAGE_KEY = "vagas.view_mode";
const DEFAULT_MODE: VagasViewMode = "kanban";
const VALID: VagasViewMode[] = ["kanban", "list"];

function readStored(): VagasViewMode {
  if (typeof window === "undefined") return DEFAULT_MODE;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return VALID.includes(raw as VagasViewMode)
    ? (raw as VagasViewMode)
    : DEFAULT_MODE;
}

/**
 * Alterna a visão de /vagas entre o board kanban (principal) e a lista com
 * filtros. Persiste em localStorage e sincroniza entre abas — mesmo padrão de
 * use-freelancers-view-mode.
 */
export function useVagasViewMode() {
  const [mode, setModeState] = useState<VagasViewMode>(readStored);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setModeState(readStored());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const setMode = useCallback((next: VagasViewMode) => {
    window.localStorage.setItem(STORAGE_KEY, next);
    setModeState(next);
  }, []);

  return { mode, setMode };
}
